import { ISapAssetDetail } from "@/types/sapAsset.type"

export const ASSET_TEMPLATE_V2_KEY = "fixed_asset_farms_v2"

export interface IAssetEditableColumn {
  key: string
  label: string
  required?: boolean
}

export const LEGACY_ASSET_EDIT_COLUMNS: IAssetEditableColumn[] = [
  { key: "company_code", label: "Company Code", required: true },
  { key: "asset_number", label: "Asset Number" },
  { key: "asset_subnumber", label: "Asset Subnumber" },
  { key: "asset_class_code", label: "Asset Class Code", required: true },
  { key: "asset_class_description", label: "Asset Class Description" },
  { key: "quantity", label: "Quantity", required: true },
  { key: "asset_description", label: "Asset Description", required: true },
  { key: "base_unit_of_measure", label: "Base Unit of Measure", required: true },
  { key: "asset_capitalization_date", label: "Asset Capitalization Date", required: true },
  { key: "cost_center", label: "Cost Center" },
  { key: "profit_center", label: "Profit Center", required: true },
  { key: "functional_area", label: "Functional Area" },
  { key: "license_plate_no", label: "License Plate No." },
  { key: "real_depreciation_area", label: "Real Depreciation Area", required: true },
  { key: "indicator_deactivation", label: "Indicator Deactivation" },
  { key: "depreciation_calculation_start_date", label: "Depreciation Start Date", required: true },
  { key: "real_depreciation_area_2", label: "Real Depreciation Area 2" },
  { key: "depreciation_key", label: "Depreciation Key", required: true },
  { key: "planned_useful_life", label: "Planned Useful Life", required: true },
  { key: "usage_object", label: "Usage Object" },
]

export const ASSET_V2_EDIT_COLUMNS: IAssetEditableColumn[] = [
  { key: "company_code", label: "Company Code", required: true },
  { key: "asset_number", label: "Asset Number" },
  { key: "asset_subnumber", label: "Asset Subnumber" },
  { key: "asset_class_code", label: "Asset Class Code", required: true },
  { key: "asset_need", label: "Kebutuhan", required: true },
  { key: "leasing", label: "Leasing (Yes/No)", required: true },
  { key: "quantity", label: "Quantity", required: true },
  { key: "asset_description", label: "Asset Description", required: true },
  { key: "unit_of_measure", label: "Unit of Measure", required: true },
  { key: "start_use_date", label: "Tanggal Asset Mulai Digunakan", required: true },
  { key: "unit_price", label: "Harga Satuan", required: true },
  {
    key: "planned_usage_years",
    label: "Rencana Aset digunakan dalam waktu berapa tahun",
  },
  { key: "remarks", label: "Keterangan" },
]

export const isAssetTemplateV2 = (
  templateKey?: string | null,
  items: ISapAssetDetail[] = [],
) => {
  if ((templateKey || "").trim().toLowerCase() === ASSET_TEMPLATE_V2_KEY) {
    return true
  }

  return items.some(item =>
    [
      "asset_need",
      "leasing",
      "unit_of_measure",
      "start_use_date",
      "unit_price",
      "planned_usage_years",
      "remarks",
    ].some(key => Object.prototype.hasOwnProperty.call(item || {}, key)),
  )
}

export const getAssetColumns = (
  templateKey?: string | null,
  items: ISapAssetDetail[] = [],
) => (isAssetTemplateV2(templateKey, items) ? ASSET_V2_EDIT_COLUMNS : LEGACY_ASSET_EDIT_COLUMNS)
